<script setup>
import { ref, computed, inject, watch, toRefs } from 'vue'

import { serviceTrack } from 'model/common'
import { useStore } from 'vuex'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  }
})
const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const store = useStore()

const data = ref({
  contact: '',
  contactType: 0,
  contactDetail: ''
})

const _w_area = inject('_w_area')

const showCTPicker = ref(false)
const showCPicker = ref(false)

const contact_type = [
  {
    text: 'WhatsApp',
    value: 0
  },
  {
    text: 'Telegram',
    value: 1
  },
  {
    text: 'Skype',
    value: 2
  },
  {
    text: 'Other',
    value: -1
  }
]

const show_contact_type = (v) => {
  console.log(v)
  const f_t = contact_type.find((e) => {
    return e.value == v
  })?.text
  return f_t
}

const whatsapp_code = computed(() => {
  return _w_area.map((item) => {
    return {
      text: item.c_code,
      value: item.c_code
    }
  })
})

watch(
  () => modelValue.value,
  (nValue) => {
    data.value = nValue
  },
  {
    deep: true,
    immediate: true
  }
)

const onConfirmCT = (e) => {
  data.value.contactType = e.value
  showCTPicker.value = false
}

const onConfirmC = (e) => {
  data.value.contactDetail = e.value
  showCPicker.value = false
}

//当前聚焦的输入框的值
const originalValue = ref(null)
//聚焦时获取当前输入框的值
const getCurrentVal = (v) => {
  originalValue.value = v
}

//失焦时判断值是否改变
const blurInput = (v) => {
  if (originalValue.value !== v) {
    serviceTrack('contact', store, 'EDIT')
  }
}

const handleChangeContact = () => {
  emit('update:modelValue', data.value)
}
</script>
<template>
  <div>
    <van-field
      :model-value="show_contact_type(data.contactType)"
      readonly
      is-link
      name="picker"
      label="Contact Type"
      class="contact_reset ranking-acquisition-contact keyowrd-ranking-contact"
      placeholder="Place select contact type"
      @click="showCTPicker = true"
      @update:model-value="handleChangeContact"
    />
    <van-popup
      v-model:show="showCTPicker"
      position="bottom"
      style="z-index: 10000"
      round
    >
      <van-picker
        :columns="contact_type"
        @confirm="onConfirmCT"
        @cancel="showCTPicker = false"
      />
    </van-popup>
    <van-field
      v-if="data.contactType === 0"
      v-model="data.contactDetail"
      is-link
      readonly
      name="picker"
      label="WhatsApp Code"
      class="contact_reset ranking-acquisition-contact keyowrd-ranking-contact"
      :class="data.contactDetail.trim().length <= 0 ? 'is-Empty' : ''"
      placeholder="Please select code"
      @click="showCPicker = true"
      @update:model-value="handleChangeContact"
    />
    <van-popup
      v-model:show="showCPicker"
      position="bottom"
      style="z-index: 10000"
      round
    >
      <van-picker
        :columns="whatsapp_code"
        @confirm="onConfirmC"
        @cancel="showCPicker = false"
      />
    </van-popup>
    <van-field
      v-model="data.contact"
      placeholder="Skype / WhatsApp / Telegram"
      input-align="right"
      clearable
      class="keyowrd-ranking-contact"
      :maxlength="100"
      :class="data.contact.trim().length <= 0 ? 'is-Empty' : ''"
      @blur="blurInput(data.contact)"
      @focus="getCurrentVal(data.contact)"
      @update:model-value="handleChangeContact"
    >
      <template #label>
        Contact
        <PopverTips
          v-show="data.contact.trim().length <= 0"
          message="Required"
          width="50px"
        />
      </template>
    </van-field>
  </div>
</template>
<style lang="scss" scoped>
.contact_reset {
  ::v-deep .van-field__label {
    width: 130px;
  }
}
.keyowrd-ranking-contact {
  :deep(.van-cell__title) {
    font-weight: bold;
    color: #1e183f;
  }

  &.is-Empty {
    box-sizing: border-box;
    border: 1px solid red;
  }
}
</style>
